import _ from 'lodash';

import type { DrawerProps } from 'antd';
import type { ProDescriptionsActionType } from "@ant-design/pro-descriptions";

import React, { useRef, useState } from 'react';
import { Button, Drawer, message,   } from 'antd';
import ProDescriptions from '@ant-design/pro-descriptions';
import ProForm, {ProFormText, ProFormDigit, } from '@ant-design/pro-form';
import PostSelector from "./../../../system/pages/Post/PostSelector";
import { Post } from './../../type/PostType';
import PostApi from '../../api/PostApi';

export interface PostDetailProps extends DrawerProps {
    post?: Post,
    actionRef?: React.MutableRefObject<ProDescriptionsActionType | undefined>,
    onFail:()=>void,
    onSuccess:()=>void,
};

const PostDetail:React.FC<PostDetailProps> = (props)=>{

    const {post, onFail, onSuccess, actionRef} = props;
    const [title, setTitle] = useState<string|undefined>(post?.name);

    return (
        <Drawer
            title={title}
            width={960}
            closable={false}
            destroyOnClose={true}
            extra={[
                <Button
                    key='closeBtn'
                    type='primary'
                    style={{backgroundColor:'red', border:0}}
                    onClick={onFail}
                >
                    关闭
                </Button>
            ]}
            {..._.omit(props, 'onSuccess', 'actionRef')}
        >
            <ProDescriptions<Post>
                column={2}
                actionRef={actionRef}
                request={async ()=>{
                    const result:Post = await PostApi.findPostById(post?.id||"");
                    setTitle(result?.name);

                    return {
                        success: true,
                        data: result,
                    };
                }}
                editable={{
                    onSave:async (keyPath:any, newData, oldData)=>{
                        const requestData:any = {
                            id: oldData?.id
                        };
                        let rTemp = requestData;
                        let nTemp = newData;

                        for(let i=0; i<keyPath.length; i++){
                            let field = keyPath[i];

                            if(i===keyPath.length-1){
                                rTemp[field] = nTemp[field];
                            }else{
                                rTemp[field] = {};
                                rTemp = rTemp[field];
                                nTemp = nTemp[field];
                            }
                        }

                        await PostApi.patchEditPost(requestData);
                        actionRef?.current?.reload();
                        if(onSuccess){
                            onSuccess();
                        }
                    }
                }}
            >
                <ProDescriptions.Item
                    dataIndex={['parentId']}
                    label="上级职务ID"
                    valueType="text"
                    copyable={false}
                    render={(dom, entity, index, action) => {
                        return (
                            <div>
                                {dom}
                            </div>
                        );
                    }}
                    renderFormItem={() => {
                        return <PostSelector />;
                    }}
                />
                <ProDescriptions.Item
                    dataIndex={['code']}
                    label="职务编码"
                    valueType="text"
                    copyable={false}
                    render={(dom, entity, index, action) => {
                        return (
                            <div>
                                {dom}
                            </div>
                        );
                    }}
                    renderFormItem={() => {
                        return <ProFormText />;
                    }}
                />
                <ProDescriptions.Item
                    dataIndex={['name']}
                    label="职务名称"
                    valueType="text"
                    copyable={false}
                    render={(dom, entity, index, action) => {
                        return (
                            <div>
                                {dom}
                            </div>
                        );
                    }}
                    renderFormItem={() => {
                        return <ProFormText />;
                    }}
                />
                <ProDescriptions.Item
                    dataIndex={['nameAbbr']}
                    label="职务简称"
                    valueType="text"
                    copyable={false}
                    render={(dom, entity, index, action) => {
                        return (
                            <div>
                                {dom}
                            </div>
                        );
                    }}
                    renderFormItem={() => {
                        return <ProFormText />;
                    }}
                />
                <ProDescriptions.Item
                    dataIndex={['sortNo']}
                    label="显示顺序"
                    valueType="text"
                    copyable={false}
                    render={(dom, entity, index, action) => {
                        return (
                            <div>
                                {dom}
                            </div>
                        );
                    }}
                    renderFormItem={() => {
                        return <ProFormDigit />;
                    }}
                />
            </ProDescriptions>
        </Drawer>
    );
};

export default PostDetail;